// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachWeekendOfInterval as fn } from "../eachWeekendOfInterval.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachWeekendOfIntervalWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default eachWeekendOfIntervalWithOptions;
